import React from "react";
import { Form, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FilterationBarContainer from "../../../components/FilterationBarContainer";

function FilterationBar(props) {
  const {
    designations,
    selectedDesignation,
    onDesignationChange,
    status,
    selectedStatus,
    onStatusChange,
  } = props;
  return (
    <FilterationBarContainer>
      <Col lg={5} className="my-1">
        <Form.Group className="input-field">
          <Form.Label className="label">Designation</Form.Label>
          <Col lg={8} md={6} sm={6}>
            <CustomReactSelect
              options={designations}
              value={selectedDesignation}
              onChange={(value) => onDesignationChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>

      <Col lg={5}>
        <Form.Group className="input-field">
          <Form.Label className="label">Status</Form.Label>
          <Col lg={8} md={6} sm={6}>
            <CustomReactSelect
              options={status}
              value={selectedStatus}
              onChange={(value) => onStatusChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
}

export default FilterationBar;
